export default __webpack_public_path__ + "static/media/payBills.70d645b6.svg";